module.exports = __webpack_public_path__ + "img/n23.b98baff8.jpg";